// Config
let configCache = null;
export const getConfig = async () => {
  if (configCache) return configCache;
  try {
    const res = await fetch("/config.json");
    configCache = await res.json();
    return configCache;
  } catch (error) {
    configCache = null;
    return configCache;
  }
};

const GET_HEADER = {
  method: "GET",
  credentials: "include",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
};
const getXSRFToken = () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("XSRF-TOKEN="))
    ?.split("=")[1];
  return decodeURIComponent(token);
};
const PUT_HEADER = (data) => {
  return {
    method: "PUT",
    credentials: "include", // cookie akan tersimpan di browser
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXSRFToken(), // <<--- WAJIB !!!
    },
    body: JSON.stringify(data),
  };
};
const DELETE_HEADER = () => {
  return {
    method: "DELETE",
    credentials: "include", // cookie akan tersimpan di browser
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXSRFToken(), // <<--- WAJIB !!!
    },
  };
};
const POST_HEADER = (data) => {
  return {
    method: "POST",
    credentials: "include", // cookie akan tersimpan di browser
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXSRFToken(), // <<--- WAJIB !!!
    },
    body: JSON.stringify(data),
  };
};
//-----//
//-----handle download jikaperlu modifikasi fileName dan monitoring progress-----//
const fileDownloader = (url, fileName = "noName", onProgress) => {
  return new Promise(async (resolve, reject) => {
    const config = await getConfig();
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `${config.baseUrl}/api${url}`, true);
    xhr.withCredentials = true;
    xhr.responseType = "blob"; // <-- kunci untuk download file
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        if (typeof onProgress === "function") {
          onProgress(percent);
        }
      }
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const disposition = xhr.getResponseHeader("Content-Disposition");
          let serverFileName = fileName;
          if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
              serverFileName = match[1].replace(/['"]/g, "");
            }
          }
          const blob = new Blob([xhr.response]);
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = serverFileName;
          link.click();

          resolve({ success: true, serverFileName });
        } catch (e) {
          reject(e);
        }
      } else {
        reject(new Error("Network error"));
      }
    };
    xhr.onerror = () => reject(new Error("Network error"));
    xhr.send();
  });
};
//-----//
//-----handle download langsung download bar browser-----//
const fileDownloader_2 = async (url) => {
  const config = await getConfig();
  const link = document.createElement("a");
  link.href = `${config.baseUrl}/api${url}`;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
//-----//
const fileUploader = (url, formData, onProgress) => {
  return new Promise(async (resolve, reject) => {
    try {
      const config = await getConfig();
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${config.baseUrl}/api${url}`, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.setRequestHeader("X-XSRF-TOKEN", getXSRFToken());
      // event untuk progress upload
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          if (typeof onProgress === "function") {
            onProgress(percent);
          }
        }
      };
      xhr.onload = () => {
        let response;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (e) {
          return reject(new Error("Invalid JSON response"));
        }

        // 🔥 Handle error status di sini
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(response);
        } else {
          reject(response);
        }
      };
      xhr.onerror = () => reject(new Error("Network error"));
      xhr.send(formData);
    } catch (err) {
      reject(err);
    }
  });
};

const POST = async (url, data) => {
  const config = await getConfig();
  const res = await fetch(`${config.baseUrl}/api${url}`, POST_HEADER(data));
  const json = await res.json();
  if (!res.ok) {
    throw {
      status: res.status,
      message: json.message,
    };
  }
  return json;
};
const GET_BLOB = async (url) => {
  try {
    const config = await getConfig();

    const res = await fetch(`${config.baseUrl}/api${url}`, GET_HEADER);

    if (!res.ok) {
      let errorMessage = "Failed to fetch file";

      try {
        const errorData = await res.json();
        errorMessage = errorData.message || errorMessage;
      } catch {
        errorMessage = await res.text();
      }

      throw {
        status: res.status,
        message: errorMessage,
      };
    }

    const blob = await res.blob();

    return blob; // ✅ langsung return blob
  } catch (err) {
    console.error("GET_BLOB Error:", err);
    throw err;
  }
};
const GET = async (url) => {
  const config = await getConfig();
  const res = await fetch(`${config.baseUrl}/api${url}`, GET_HEADER);
  const json = await res.json();
  if (!res.ok) {
    throw {
      status: res.status,
      message: json.message,
    };
  }
  return json;
};
const PUT = async (url, data) => {
  const config = await getConfig();
  const res = await fetch(`${config.baseUrl}/api${url}`, PUT_HEADER(data));
  const json = await res.json();
  if (!res.ok) {
    throw {
      status: res.status,
      message: json.message,
    };
  }
  return json;
};
const DELETE = async (url) => {
  const config = await getConfig();
  const res = await fetch(`${config.baseUrl}/api${url}`, DELETE_HEADER());
  const json = await res.json();
  if (!res.ok) {
    throw {
      status: res.status,
      message: json.message,
    };
  }
  return json;
};

// Auth
export async function csrf() {
  const config = await getConfig();
  await fetch(`${config.baseUrl}/sanctum/csrf-cookie`, {
    method: "GET",
    credentials: "include", // WAJIB
  });
}
export async function login(name, password) {
  const config = await getConfig();
  await csrf();
  const res = await fetch(`${config.baseUrl}/login`, {
    // const res = await fetch(`${config.baseUrl}/login`, {
    method: "POST",
    credentials: "include", // cookie akan tersimpan di browser
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXSRFToken(), // <<--- WAJIB !!!
    },
    body: JSON.stringify({ name, password }),
  });

  if (!res.ok) throw new Error("Login gagal");
}
export async function logout() {
  const config = await getConfig();
  await fetch(`${config.baseUrl}/logout`, {
    method: "POST",
    credentials: "include",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXSRFToken(),
    },
  });
}
export const getDataUser = async () => GET("/user");
export const imageUser = async (url) => GET(url);
export const iconPpdMaco = async () => GET(`/generalImage/ppd-maco-icon`);

//Profil
export const profileImage = async (url) => GET(url);
export const profilePutPhone = async (phone) => PUT("/user-edit/phone", phone);
export const profilePutName = async (name) => PUT("user-edit/name", name);
export const profilePutPassword = async (pass) => PUT("user-edit/pass", pass);
export const profileUploadImage = async (formData, onProgress) => fileUploader("/userImage-set", formData, onProgress);

// Manpower
// -----Data
export const listManpowerAll = async (search = "", page = "") => GET(`/manpowerv2?search=${search}&page=${page}`);
export const listManpowerPlant = async (search = "", page = "") => GET(`/manpowerv2/plant?search=${search}&page=${page}`);
export const listManpowerNotActive = async (search = "", page = "") => GET(`/manpowerv2/notActive?search=${search}&page=${page}`);
export const listManpowerMiniResume = async () => GET(`/manpowerv2/miniResume`);
export const iconUpdater = async (id = 0) => GET(`/manpowerv2/getUpdaterImage?id=${id}`);
// -----Dashboard
export const dashboardMechanicTotal = async () => GET(`/get-manpower-dashboard/mechanic-total`);
export const dashboardMechanicGrowth = async () => GET(`/get-manpower-dashboard/mechanic-growth`);
export const dashboardMechanicTop7 = async () => GET(`/manpowerv2/top7`);
export const dashboardMechanicByGrade = async (grade, page) => GET(`/get-manpower-dashboard/mechanic-list-by-grade?grade=${grade}&page=${page}`);
export const dashboardMechanicBySpcl = async (spcl, page) => GET(`/get-manpower-dashboard/mechanic-list-by-spcl?spcl=${spcl}&page=${page}`);

// -----Profile
export const profileManpower = async (id) => GET(`/manpowerv2/profile?id=${id}`);
export const profileManpowerMain = async (id) => GET(`/manpowerv2/mainProfile?manpowerId=${id}`);
export const profileManpowerTraining = async (id) => GET(`/manpowerv2/trainings?manpowerId=${id}`);
export const profileManpowerPersonalGalery = async (id) => GET(`/getPersonalGalery/${id}`);
export const profileManpowerDocument = async (id) => GET(`/getInfoManpowerDocument/${id}`);
export const profileManpowerDelete = async (id) => GET(`/manpowerv2delete/${id}`);
export const profileManpowerUploadGalery = async (formData, onProgress) => fileUploader("/postImagePersonalGalery", formData, onProgress);

export const profileManpowerDeleteGalery = async (id) => DELETE(`/delpersonalgalery/${id}`);
export const profileManpowerUploadDocument = async (formData, onProgress) => fileUploader("/uploadManpowerDocument", formData, onProgress);
export const profileManpowerDeleteDocument = async (id) => DELETE(`/deleteManpowerDocument/${id}`);
export const profileManpowerDownloadDoc = async (id, fileName, opProgress) => fileDownloader(`/downloadManpowerDocument/${id}`, fileName, opProgress);
export const profileManpowerDwonloadDocument = async (id) => GET(`/downloadManpowerDocument/${id}`);
export const profileManpowerDwonloadMetaDataDocument = async (id) => GET(`/getFileNameManpowerDocument/${id}`);
// -----Edit
export const editManpowerGetOneData = async (id) => GET(`/manpowerv2/oneData?id=${id}`);
export const editManpowerEdit = async (data) => PUT(`/manpowerv2edit`, data);
export const editManpowerFoto = async (formData, onProgress) => fileUploader("/postImage/profileImageEdit", formData, onProgress);
// -----New Manpower
export const newManpowerSubmit = async (data) => POST("/manpowerv2submit", data);
// Training
// -----Dashboard
export const dashboardTrainingInstructorHour = async () => GET(`/training/instructor-teaching-day`);
export const dashboardTrainingMostTraining = async () => GET(`/training/mechanic-training-statistic`);
// -----Data
export const dataTrainningAll = async (search = "", page = "") => GET(`/training/all?search=${search}&page=${page}`);
// -----Detail
export const detailTrainingSingle = async (id) => GET(`/training/show-training-event?trId=${id}`);
export const detailTrainingPeserta = async (id) => GET(`/training/peserta/${id}`);
export const detailTrainingParticipants = async (id) => GET(`/training/participants?trainingId=${id}`);
export const detailTrainingTel2All = async (id) => GET(`/training/tel2?trainingId=${id}`);
export const detailTrainingFileList = async (id) => GET(`/training/file-list?trainingId=${id}`);
export const detailTrainingTel1 = async (id) => GET(`/training/tel1?trainingId=${id}`);
export const detailTrainingTel1ForExport = async (id) => GET(`/training/tel1-export?trainingId=${id}`);
export const detailTrainingTel1Change = async (data) => PUT(`/training/tel1-link`, data);
export const detailTrainingTel1Unlink = async (data) => PUT(`/training/tel1-unlink`, data);
export const detailTrainingUploadFile = async (formData, onProgress) => fileUploader("/training/file-upload", formData, onProgress);
export const detailTrainingDownloadFile = async (id) => fileDownloader_2(`/training/file-download?trainingDocumentId=${id}`);
//
export const detailTrainingDeleteFile = async (id) => DELETE(`/training/file?fileId=${id}`);
export const detailTrainingReportAmi = async (id) => GET(`/training/report-ami?trainingId=${id}`);
export const detailTrainingReportKmkop = async (id) => GET(`/training/report-kmkop?trainingId=${id}`);
export const detailTrainingDeleteParticipant = async (id) => DELETE(`/training/participant?partId=${id}`);
export const detailTrainingDeleteEvent = async (id) => DELETE(`/training/event?trainingId=${id}`);
export const detailTrainingDeleteUkPart = async (id) => DELETE(`/trainingDelete/uk-part/${id}`);
export const detailTrainingDeleteUk = async (id) => DELETE(`/trainingDelete/uk/${id}`);
export const detailTrainingDeleteTel2ParticipantEvaluation = async (id) => DELETE(`/training/tel2-evaluation?tel2EvaluationId=${id}`);
export const detailTrainingDeleteTel2Competency = async (id) => DELETE(`/training/tel2-competency?tel2CompetencyId=${id}`);
//
export const detailTrainingEditMain = async (data) => PUT(`/training/main`, data);
export const detailTrainingEditPeserta = async (val) => PUT(`/training/participant`, val);
export const detailTrainingEditUkPeserta = async (val) => PUT(`/training-edit/uk-part`, val);
export const detailTrainingEditUk = async (val) => PUT(`/training-edit/uk`, val);
export const detailTrainingEditTel2Competency = async (val) => PUT(`/training/competency`, val);
export const detailTrainingeDITTel2Evaluation = async (data) => PUT(`/training/evaluation`, data);
//
export const detailTrainingNewParticipant = async (data) => POST(`/training/new-participant`, data);
export const detailTrainingNewUk = async (data) => POST(`/trainingSubmit/uk-set`, data);
export const detailTrainingNewUkPart = async (data) => POST(`/trainingSubmit/uk-part`, data);
export const detailTrainingImportScore = async (data) => POST(`/training/import-test-result`, data);
export const detailTrainingNewTel2Evaluation = async (data) => POST(`/training/tel2-evaluation`, data);
export const detailTrainingTel2NewCompetency = async (data) => POST(`/training/tel2-competency`, data);
export const detailTrainingGetLogoAMI = async (url) => GET(url);
export const detailTrainingGetLogoSis = async (url) => GET(url);
export const detailTrainingTel3Data = async (id) => GET(`/training/tel3?trainingId=${id}`);
// -----ATMP
export const atmpTrainingMain = async (search = "", page = "", year = "") => GET(`/training/atmp-main?search=${search}&page=${page}&year=${year}`);
export const atmpTrainingSummary = async (year) => GET(`/training/atmp-summary?year=${year}`);
export const atmpTrainingDetail = async (id) => GET(`/training/atmp-detail?atmpMainId=${id}`);
// -----Plan Training
export const planTrainingAll = async (search = "", page = "") => GET(`/plan-training/main-list?search=${search}&page=${page}`);
export const planTrainingMainOne = async (id) => GET(`/plan-training/main-one?id=${id}`);
export const planTrainingParticipant = async (id) => GET(`/plan-training/participant?id=${id}`);
export const planTrainingGetForTaf = async (id) => GET(`/plan-training/one-set-for-taf?id=${id}`);
export const planTrainingEditMain = async (data) => PUT(`/plan-training-edit/main`, data);
export const planTrainingEditStatus = async (data) => PUT(`/plan-training-edit/status`, data);
export const planTrainingParticipantCancle = async (data) => PUT(`/plan-training-edit/participant-to-cancle`, data);
export const planTrainingParticipantOk = async (data) => PUT(`/plan-training-edit/participant-to-ok`, data);
export const planTrainingNewParticipant = async (data) => POST(`/plan-training-new/participant`, data);
export const planTrainingNewMain = async (data) => POST(`/plan-training-new/main`, data);
export const planTrainingDelete = async (id) => DELETE(`/plan-training-delete/plan-one-set?id=${id}`);
// -----New Record
export const newTrainingRecordMain = async (data) => POST(`/training/new-event`, data);
export const newTrainingRecordEditPeserta = async (val) => PUT(`/training-edit/peserta`, val);
export const newTrainingGetPeserta = async (id) => GET(`/training/peserta/${id}`);
export const newTrainingDeletePeserta = async (id) => DELETE(`/trainingDelete/deletePeserta/${id}`);
export const newTrainingRecordParticipant = async (data) => POST(`/trainingSubmit/newParticipant`, data);
export const newTrainingDocumentUpload = async (data, onProgress) => fileUploader(`/training-uploadDocument`, data, onProgress);
export const newTrainingDocumentGet = async (id) => GET(`/training/document/${id}`);
export const newTrainingDocumentDownload = async (id, fileName, onProgress) => fileDownloader(`/training-document/${id}`, fileName, onProgress);
export const newTrainingDocumentDelete = async (id) => DELETE(`/training-deleteDocument/${id}`);
// Mentoring
// -----Data Mentoring
export const dataMentoringList = async (search = "", page = "") => GET(`/mentoring/all?search=${search}&page=${page}`);
export const dataMentoringGetOne = async (id) => GET(`/mentoring/single?id=${id}`);
export const dataMentoringGetDocument = async (id) => GET(`/mentoring/document?id=${id}`);
export const dataMentoringDeleteEvt = async (id) => DELETE(`/mentoring-delete/event?id=${id}`);
export const dataMentoringEditMain = async (data) => PUT(`/mentoring-edit/main`, data);
export const dataMentoringDeleteDocument = async (id) => DELETE(`/mentoring-delete/file?id=${id}`);
export const dataMentoringDownloadDoc = async (id, fileName, onProgress) => fileDownloader(`/mentoring/download-document?id=${id}`, fileName, onProgress);
export const dataMentoringDownloadUpload = async (data, onProgress) => fileUploader(`/mentoring-submit/file`, data, onProgress);
// -----New Mentoring
export const newMentoringSubmit = async (data) => POST(`/mentoring-submit/new`, data);
export const newMentoringDeleteDocument = async (id) => DELETE(`/mentoring-deleteDocument/${id}`);
export const newMentoringDownloadDoc = async (id, fileName, onProgress) => fileDownloader(`/mentoring-document?id=${id}`, fileName, onProgress);
export const newMentoringDownloadUpload = async (data, onProgress) => fileUploader(`/mentoring-uploadDocument`, data, onProgress);
export const newMentoringGetDocument = async (id) => GET(`/mentoring/document/${id}`);
// Question
// -----Data
export const questDataMain = async (search = "", page = "") => GET(`/question-get/all-main?search=${search}&page=${page}`);
export const questDataNewmain = async (data) => POST(`/question-new/main`, data);
export const questDataDificulty = async (id) => GET(`/question-get/get-top5Dificulty/${id}`);
export const questDataEvtRes = async (id) => GET(`/question-event/client-result/${id}`);
// -----Detail
export const detailQuestEditMain = async (data) => PUT(`/question-edit/soal-main`, data);
export const detailQuestDeleteMain = async (id) => DELETE(`/question-delete/main/${id}`);
export const detailQuestEditMc = async (id, data) => PUT(`/question-edit/multiple-choice/${id}`, data);
export const detailQuestEditMcStatus = async (id, data) => PUT(`/question-edit/soal-mc-status/${id}`, data);
export const detailQuestDeleteMc = async (id) => DELETE(`/question-delete/mc/${id}`);
export const detailQuestDeleteTf = async (id) => DELETE(`/question-delete/tf/${id}`);
export const detailQuestEditTf = async (id, data) => PUT(`/question-edit/true-false/${id}`, data);
export const detailQuestNewTf = async (id, data) => POST(`/question-new/new-tf/${id}`, data);
export const detailQuestEditTfStatus = async (id, data) => PUT(`/question-edit/soal-tf-status/${id}`, data);
export const detailQuestNewMc = async (id, data) => POST(`/question-new/new-mc/${id}`, data);
export const detailQuestNewMatch = async (id, data) => POST(`/question-new/new-choice-match/${id}`, data);
export const detailQuestNewMatch_1 = async (id, data) => POST(`/question-new/soal-matching-1/${id}`, data);
export const detailQuestEditMatch_1 = async (id, data) => PUT(`/question-edit/matching1-soal/${id}`, data);
export const detailQuestEditMainMatch_1 = async (id, data) => PUT(`/question-edit/matching-main/${id}`, data);
export const detailQuestEditAnsMatch_1 = async (id, data) => PUT(`/question-edit/matching1-jawaban/${id}`, data);
export const detailQuestDeleteMatch_1 = async (id) => DELETE(`/question-delete/match-soal/${id}`);
export const detailQuestDeleteAnsMatch_1 = async (id) => DELETE(`/question-delete/jawaban-match-1/${id}`);
export const detailQuestDeleteMainMatch_1 = async (id) => DELETE(`/question-delete/match-1/${id}`);
export const detailQuestNewMatchMain_1 = async (id, data) => POST(`/question-new/soal-matching-main-1/${id}`, data);
export const detailQuestNewMatch_2 = async (id, data) => POST(`/question-new/soal-matching-2/${id}`, data);
export const detailQuestEditMatch_2 = async (id, data) => PUT(`/question-edit/matching2-soal/${id}`, data);
export const detailQuestEditImageMatch_2 = async (id, data) => PUT(`/question-edit/soal-matching-image/${id}`, data);
export const detailQuestDeleteMatch_2 = async (id) => DELETE(`/question-delete/match-soal/${id}`);
export const detailQuestDeleteMainMatch_2 = async (id) => DELETE(`/question-delete/match-2/${id}`);
export const detailQuestNewMatchMain_2 = async (id, data) => POST(`/question-new/soal-matching-main-2/${id}`, data);
export const detailQuestStatusMatch = async (id, data) => PUT(`/question-edit/matching-status/${id}`, data);
export const detailQuestEventSubmit = async (id, data) => POST(`/question-event-new/new/${id}`, data);
export const detailQuestGetOneSet = async (id) => GET(`/question-get/one-set/${id}`);
export const detailQuestGetOneMc = async (id) => GET(`/question-get/one-question/${id}`);
export const detailQuestGetOneTf = async (id) => GET(`/question-get/one-tf/${id}`);
export const detailQuestGetOneQuestMatch_1 = async (id) => GET(`/question-get/one-matching-soal-1/${id}`);
export const detailQuestGetOneAnsMatch_1 = async (id) => GET(`/question-get/one-matching-jawaban-1/${id}`);
export const detailQuestGetOneMainMatch_1 = async (id) => GET(`/question-get/one-matching-main-1/${id}`);
export const detailQuestGetOneMainMatch_2 = async (id) => GET(`/question-get/one-matching-soal-2/${id}`);
export const detailQuestEventPreset = async (id) => GET(`/question-event/preset/${id}`);
export const detailQuestImg = async (url) => GET(url);
export const detailQuestionGenerateEpdTemp = async (id, title, onProgress) => fileDownloader(`/question-template?id=${id}&judul=${title}`, "No Name", onProgress);
// export const detailQuestionGenerateEpdTemp = async (id, title) => GET(`/question-template?id=${id}&judul=${title}`);
// -----Event
export const eventQuestList = async (search = "", page = "") => GET(`/question-event/event-list?search=${search}&page=${page}`);
export const eventQuestDeleteEvt = async (id, search) => DELETE(`/question-event-delete/event-one/${id}?search=${search}`);
export const eventQuestResult = async (id) => GET(`/question-event/event-result/${id}`);
export const eventQuestResExtraBtn = async (data) => PUT(`/question-event-edit/add-extra-time`, data);

// Training Evaluasi lvl 1
// -----Data
export const dataTel1GetList = async (search = "", page = "") => GET(`/training-evaluasi/all?search=${search}&page=${page}`);
export const dataTel1DeleteEvt = async (id) => DELETE(`/training-evaluasi-delete/event-main/${id}`);
export const dataTel1NewEvt = async (data) => POST(`/training-evaluasi-post/event`, data);
export const dataTel1EvtRes = async (id) => GET(`/training-evaluasi/event-results?id=${id}`);
export const dataTel1EditMain = async (data) => PUT(`/training-evaluasi-edit/event-main`, data);
export const dataTel1ExtraTime = async (data) => PUT(`/training-evaluasi-edit/extra-btn`, data);
// Training Evaluasi lvl 3
// -----Data
export const dataTel3GetList = async (search = "", page = "") => GET(`/tel3/list-main?search=${search}&page=${page}`);
export const dataTel3GetDetail = async (id) => GET(`/tel3/detail?id=${id}`);
export const dataTel3GetDetailPart = async (id) => GET(`/tel3/detail-part?partId=${id}`);
export const dataTel3SignImage = async (id) => GET_BLOB(`/tel3/sign-image?id=${id}`);
export const dataTel3GetUkList = async (id) => GET(`/tel3/uk-list?trId=${id}`);
export const dataTel3GetOutstanding = async (search = "", page = "") => GET(`/tel3/outstanding?search=${search}&page=${page}`);
export const dataTel3PostNewMain = async (data) => POST(`/tel3/new-preset`, data);
export const dataTel3PostSendLinksMessages = async (data) => POST(`/tel3/send-messages`, data);
export const dataTel3PostNewPartUk = async (data) => POST(`/tel3/new-part-moreuk`, data);
export const dataTel3PostNewPresetPart = async (data) => POST(`/tel3/new-preset-part`, data);
export const dataTel3DelPart = async (id) => DELETE(`/tel3/participant?id=${id}`);
export const dataTel3DelEvt = async (id) => DELETE(`/tel3/one-set?id=${id}`);
export const dataTel3EditEval = async (data) => PUT(`/tel3/evaluator`, data);
export const dataTel3EditLinkRelink = async (data) => PUT(`/tel3/reload-link`, data);
// Regulation
// -----Data
export const dataReagulationGetList = async (search = "", page = "") => GET(`/regulation-get/all-data?search=${search}&page=${page}`);
export const dataRegulationDelete = async (id) => DELETE(`/regulation-delete/${id}`);
export const dataRegulationNew = async (formData, onProgress) => fileUploader(`/regulation-new/new`, formData, onProgress);
export const dataRegulationEditOne = async (formData, onProgress) => fileUploader(`/regulation-edit/edit-one`, formData, onProgress);
export const dataRegulationDownloadDoc = async (id) => fileDownloader_2(`/regulation-get/file?id=${id}`);
export const dataRegulationGetOneData = async (id) => GET(`/regulation-get/one-data/${id}`);
// KPI
export const kpiGetTeam = async () => GET(`/performance/team`);
export const kpiGetIndividu = async (id = "") => GET(`/performance/individu?id=${id}`);
export const kpiGetIndividuNoId = async () => GET(`/kpi/individu`);
export const kpiGetTeamOtherActivityByIdAndMonth = async (kpiId, year, month) => GET(`/performance/other-by-month-and-item?kpiId=${kpiId}&year=${year}&month=${month}`);
// Readiness
export const readStats = async () => GET("/stats");
export const readServer = async () => GET(`/server`);
export const readResumeMech = async () => GET(`/get-dashboard-readiness-mechanic/resume`);
export const readResumeAllMech = async () => GET(`/resumeRead`);
export const readGradeQty = async () => GET(`/gradeqty`);
export const readManpowerQtyLog = async () => GET(`/qtymanpowerlog`);
export const readMechHiLvl = async () => GET(`/highlvl`);
// Other Activity
export const otherActivityList = async (search = "", page = "") => GET(`/other-activity/data?search=${search}&page=${page}`);
export const otherActivityDetail = async (id) => GET(`/other-activity/detail?id=${id}`);
export const otherActivityGetFile = async (id) => fileDownloader_2(`/other-activity/file?id=${id}`);
export const otherActivityPostFile = async (formData, onProgress) => fileUploader(`/other-activity/evident-file`, formData, onProgress);
export const otherActivityNewRecord = async (data) => POST(`/other-activity/new-report-activity`, data);
export const otherActivityEdit = async (url, data) => PUT(`/other-activity${url}`, data);
export const otherActivityDeleteFile = async (id) => DELETE(`/other-activity/evident-file?id=${id}`);
export const otherActivityDeleteRecord = async (id) => DELETE(`/other-activity/report-delete?id=${id}`);
// Selector
export const optionSelector = async (url) => GET(`/optionselector${url}`);
// messaging
// -----whatsapp
export const whatsappGetOutgoing = async (search = "", page = "") => GET(`/whatsapp/get-outgoing?search=${search}&page=${page}`);

// =================================
//General Image
export const generalImage = async (url) => GET_BLOB(`/generalImage${url}`);

// =================================
